import {CSSProperties, FC} from 'react';


export interface IIconToolsNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconToolsNissan: FC<IIconToolsNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m18.096 12.433-2.641 2.64c-.3.299-.738.413-1.143.298l-2.59-.735-.088-.088-.05.049-1.072-.305a1.158 1.158 0 0 1-.804-.804l-.304-1.072.049-.049-.088-.088-.735-2.59a1.168 1.168 0 0 1 .297-1.144l2.64-2.64a1.17 1.17 0 0 1 1.144-.297l1.016.288-2.942 2.943.73 3.646 3.647.73 2.942-2.942.29 1.016c.114.406 0 .845-.298 1.144Zm1.8-1.57-.428-1.512a1.25 1.25 0 0 0-.896-.877c-.437-.114-.89.01-1.209.33l-2.715 2.714-1.804-.36-.362-1.806 2.715-2.715c.32-.32.443-.771.329-1.208a1.25 1.25 0 0 0-.877-.896l-1.511-.43a2.731 2.731 0 0 0-2.675.697L7.82 7.44a2.731 2.731 0 0 0-.695 2.676l.53 1.867L4 15.638l1.09 1.09 3.048-3.046.066.233c.26.918.963 1.62 1.881 1.88l.234.067-3.047 3.048L8.362 20l3.655-3.655 1.868.53a2.734 2.734 0 0 0 2.675-.696l2.64-2.641a2.732 2.732 0 0 0 .697-2.675Z" />
        </svg>
    );
};
